import { useMemo } from 'react';
import { doesExist } from 'utils/tsHelpers';
import { useRequirementDataTypeFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';
import { ClientDataType } from '../../../types';

export const useHasRequirementDataTypeError = (dataType: ClientDataType) => {
  const fieldPath = useRequirementDataTypeFieldPath();
  const { getHasErrorFromFieldPath } = useQueryErrorStateContext();
  const errorFromFieldPath = getHasErrorFromFieldPath(fieldPath);

  return useMemo(() => {
    if (doesExist(dataType)) return false;
    else return errorFromFieldPath;
  }, [dataType, errorFromFieldPath]);
};
